import React from 'react';

// Events
import Goal from './Goal';
import GoalDisallowed from './GoalDisallowed';
import ShotBlocked from './ShotBlocked';
import ShotHitPost from './ShotHitPost';
import ShotMissed from './ShotMissed';
import ShotSaved from './ShotSaved';
import Unknown from '../Unknown';


function determineEventComponent(event){
  // Video review for disallowed goals
  if(event.review && event.review.outcome === 'goalReviewNoGood'){
    return GoalDisallowed; 
  }

  switch(event.result.type){
    case 'goal':
      return Goal;
    case 'shotBlocked':
      return ShotBlocked;
    case 'shotHitPost':
      return ShotHitPost;
    case 'shotSaved':
      return ShotSaved;
    case 'shotMissed':
      return ShotMissed;
    default:
      return Unknown;
  }
}


function GameShotEvents(props) {
  const Component = determineEventComponent(props.event)
  return <Component {...props} />
}

export default GameShotEvents;
